import axios from 'axios';
import {backendHost} from '../../config';

export const getPartners = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/partners`, {params});
};